export default "__VITE_ASSET__BoleIxbC__"